import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IRootState } from '@app/store';

export type VariantType = 'default' | 'error' | 'success' | 'warning' | 'info';

export interface IModalNotification {
  title: string;
  message: string;
  variant: VariantType;
}

export interface IModalNotificationState {
  notification: IModalNotification | null;
}

const initialState: IModalNotificationState = {
  notification: null,
};

export const selectModalNotification = (state: IRootState) =>
  state.modal_notification.notification;

export const modalNotificationSlice = createSlice({
  name: 'modal_notification',
  initialState,
  reducers: {
    setModalNotification: (
      state,
      action: PayloadAction<IModalNotification | null>
    ) => {
      state.notification = action.payload;
    },
  },
});

export const { setModalNotification } = modalNotificationSlice.actions;

export default modalNotificationSlice.reducer;
